module.exports = __webpack_public_path__ + "img/temperature.86d619b.svg";